import icon_apk from "./images/icon_apk.png";
import icon_audio from "./images/icon_audio.png";
import icon_bmp from "./images/icon_bmp.png";
import icon_doc from "./images/icon_doc.png";
import icon_eps from "./images/icon_eps.png";
import icon_gif from "./images/icon_gif.png";
import icon_html from "./images/icon_html.png";
import icon_pdf from "./images/icon_pdf.png";
import icon_picture from "./images/icon_picture.png";
import icon_ppt from "./images/icon_ppt.png";
import icon_psd from "./images/icon_psd.png";
import icon_svg from "./images/icon_svg.png";
import icon_tiff from "./images/icon_tiff.png";
import icon_txt from "./images/icon_txt.png";
import icon_video from "./images/icon_video.png";
import icon_vis from "./images/icon_vis.png";
import icon_weizhiwenjian from "./images/icon_weizhiwenjian.png";
import icon_xls from "./images/icon_xls.png";
import icon_xml from "./images/icon_xml.png";
import icon_yasuo from "./images/icon_yasuo.png";
import "./index.less";

type Props = {
  fileName: string;
  width?: string;
  height?: string;
};
const FileIcon = (props: Props) => {
  const { fileName, width, height } = props;
  // 根据文件名返回对应的文件图标
  const getFileTypeIcon = () => {
    const fileExtension =
      fileName?.split(".")?.pop()?.toLocaleUpperCase() || "UNKNOWN";
    const fileTypeIconMap = {
      // 文本文件:
      TXT: icon_txt,
      MARKDOWN: icon_txt,
      CSV: icon_txt,
      JSON: icon_txt,
      XML: icon_xml,
      HTML: icon_html,
      CSS: icon_txt,
      // 图像文件:
      JPG: icon_picture,
      JPEG: icon_picture,
      PNG: icon_picture,
      GIF: icon_gif,
      BMP: icon_bmp,
      SVG: icon_svg,
      TIFF: icon_tiff,
      // 音频文件:
      MP3: icon_audio,
      WAV: icon_audio,
      FLAC: icon_audio,
      AAC: icon_audio,
      OGG: icon_audio,
      // 视频文件:
      MP4: icon_video,
      AVI: icon_video,
      MKV: icon_video,
      MOV: icon_video,
      WMV: icon_video,
      // 压缩文件:
      ZIP: icon_yasuo,
      RAR: icon_yasuo,
      "7Z": icon_yasuo,
      TAR: icon_yasuo,
      GZ: icon_yasuo,
      // 文档文件:
      DOC: icon_doc,
      DOCX: icon_doc,
      XLS: icon_xls,
      XLSX: icon_xls,
      PPT: icon_ppt,
      PPTX: icon_ppt,
      PDF: icon_pdf,
      PSD: icon_psd,
      APK: icon_apk,
      VIS: icon_vis,
      EPS: icon_eps,
      OPENDOCUMENT: icon_weizhiwenjian,
      // 程序文件:
      JAVASCRIPT: icon_weizhiwenjian,
      PYTHON: icon_weizhiwenjian,
      JAVA: icon_weizhiwenjian,
      CPP: icon_weizhiwenjian, // C++
      CS: icon_weizhiwenjian, // C#
      RUBY: icon_weizhiwenjian,
      // 数据库文件:
      SQLITE: icon_weizhiwenjian,
      MYSQL: icon_weizhiwenjian,
      // 字体文件:
      TRUETYPE: icon_weizhiwenjian,
      OPENTYPE: icon_weizhiwenjian,
      // 未知类型文件:
      UNKNOWN: icon_weizhiwenjian,
    } as Record<string, any>;
    return fileTypeIconMap[fileExtension] ?? icon_weizhiwenjian;
  };

  return (
    <img
      src={getFileTypeIcon()}
      width={width || "40px"}
      height={height || "40px"}
    />
  );
};

export default FileIcon;
